



















import { Component, Prop, Vue } from "vue-property-decorator";
import PostCountBox from "./PostCountBox/PostCountBox.vue";
@Component({
  components: {
    PostCountBox
  }
})
export default class ExceptionPost extends Vue {
  @Prop({
    default: "empty_post"
  })
  type?: string;

  get exceptionText() {
    return this.type === "empty_post"
      ? "No post yet"
      : "This account is private.";
  }
}
